<template>
  <px-lateral-dialog v-model="dialog"
                     width="550">
    <template v-slot:activator="{ on }">
      <v-btn class="normal-btn-text elevation-0 rounded-tag-small ml-2"
             v-on="on">
        <v-icon>mdi-file-pdf-box</v-icon>
        Gerar PDF
      </v-btn>
    </template>
    <template v-slot:title>
      Ordem de compra pendente
    </template>
    <template>
      <div>
        Esta ordem de compra ainda está
        <span class="font-weight-bold amber--text text--darken-1">pendente</span> de aprovação.
        <b>Por favor, aprove o pedido após conferir a ordem de compra.</b>
      </div>
    </template>
    <template v-slot:actions>
      <v-spacer/>
      <v-btn @click="close"
             class="normal-btn-text rounded-tag-small elevation-0">
        Fechar
      </v-btn>
      <px-finalizacao-print-pdf-btn color="primary"
                                    :compra-id="compraId"
                                    :compra="compra"/>
    </template>
  </px-lateral-dialog>
</template>

<script>
import FinalizacaoPrintPdfBtn from '@/modules/finalizacao/FinalizacaoPrintPdfBtn.vue';

export default {
  props: {
    compraId: String,
    compra: Object,
  },
  data() {
    return {
      dialog: false,
    };
  },
  methods: {
    close() {
      this.dialog = false;
    },
  },
  components: {
    pxFinalizacaoPrintPdfBtn: FinalizacaoPrintPdfBtn,
  },
};
</script>
